export default {
    sellerName: ['seller_name'],
    lotNumber: ['lot_number'],
    ownerName: ['owner_name'],
    claimNumber: ['claim_number'],
    vehicleYear: ['vehicle_year'],
    vehicleModel: ['vehicle_model'],
    vehicleMake: ['vehicle_make'],
    vehicleColor: ['vehicle_color'],
    vin: ['vin'],

    addressLine1: ['address','address1'],
    addressLine2: ['address','address2'],
    city: ['address','city'],
    state: ['address','state'],
    zip: ['address','zip'],

    removedPersonalBelongings: ['removed_personal_belongings'],
    readyForPickup: ['ready_for_pickup'],
    hasKeys: ['has_keys'],
    policyHolder: ['policy_holder'],
    isTitleAvailable: ['is_title_available'],
    isOwnerTitle: ['is_owner_title'],
    actualOwnerName: ['actual_owner_name'],
    ownerRelation: ['owner_relation'],
    titleClear: ['title_clear'],
    lienInstitution: ['lien_institution'],
    sellerType: ['seller_type'],
    signTime: ['sign_time'],
    signTitle: ['sign_title'],
    frontPhoto: ['front_photo'],
    backPhoto: ['back_photo'],
    vehiclePhoto: ['vehicle_photo'],
    ownerPresent: ['owner_present'],
    pickupTime: ['pickup_time'],
    pickupTime1: ['pickup_time1'],
    before_ten: ['before_ten'],
    after_five: ['after_five'],
    pickUpOn: ['pick_up_on'],
    vehicleIsBlocked: ['vehicle_is_blocked'],
    doesWheelsRoll: ['does_wheels_roll'],
    followUp: ['follow_up'],
    comments: ['comments'],
    keysLocation: ['key_location'],

    statusMessage: ['message'],
    isSubmitted: ['is_submitted'],
    needToBeThereForPickup: ['need_to_present_for_pickup'],
    yardPhoneNumber: ['yard_phone_number'],
    maxAllowedPickupDays: ['max_allowed_pickup_days'],
    holidays: ['holidays']
}



// WEBPACK FOOTER //
// ./src/serviceMappers/lot.js